import { Link } from 'react-router-dom';

const CategoryCard = ({ category, index = 0 }) => {
  return (
    <Link 
      to={`/products/${category.id}`}
      className={`category-card group block h-48 opacity-0 animate-fade-in-up stagger-${(index % 6) + 1}`}
      data-testid={`category-card-${category.id}`}
    >
      {category.image_url ? (
        <img 
          src={category.image_url} 
          alt={category.name}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-green-800 to-green-900" />
      )}
      
      <div className="absolute inset-0 z-10 flex items-end p-4">
        <div>
          <h3 className="text-white font-bold text-lg group-hover:text-green-200 transition-colors" data-testid="category-name">
            {category.name}
          </h3>
          {category.description && (
            <p className="text-white/70 text-sm mt-1 line-clamp-2">
              {category.description}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
